<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-10-21-savotta_throwdown";
    let title = "Salikisa Savotta Throwdown 9.11.2024";
    let titlePic = "/svelte-site/img/ajankohtaista/savottathrowdown_pieni.png";
    let firstPara = "9.11. Savotta Throwdown salikisojen aikaan sali kiinni muilta harjoittelijoilta klo 11-18 välineiden puutteen vuoksi (välineet ovat käytössä) ";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <h1>{title}</h1>
                    <p><b>SAVOTTA THROWDOWN 2024</b></p>
                    <p>
                        Toiminnallisen harjoittelun yksilökilpailu Dynamosalin jäsenille Lauantaina 9.11.2024.</p>
                    <p>
                        Tapahtuma on tarkoitettu Dynamosalin jäsenille, tapahtumaan voit osallistua korttityypistä
                        riippumatta.
                        Perheenjäsenet ja ystävät ovat tervetulleita kannustamaan, muuta ns. ulkopuolista yleisöä ei
                        voida tapahtumaan ottaa.</p>
                    <p>
                        Kaikkien tapahtumassa vierailevien ja osallistujien kesken arvotaan Kampaamoluona.fi lahjoittama
                        tuotelahjapakkaus ja Liikuntapalvelut Maija Karvonen lahjoittama 60min opiskelijahieronta.</p>
                    <p>
                        Kaikkien kilpailuun ilmottautuneiden kilpailijoiden ja vapaaehtoisten kesken arvotaan 30€
                        lahjakortti Uittokalusto.fi verkkokauppaan.</p>
                    <p>
                        Ilmoittautua voi linkin lomakkeen kautta tai salin seinältä löytyvään listaan.
                        https://forms.gle/XKVPHUjQssZW85sz7.</p>
                    <p>
                        Vapaaehtoisia tarvitaan kisan tuomarointiin ja muihin avustaviin tehtäviin. (Tuomareille ja
                        vapaaehtoisille tarjolla pientä purtavaa ja virvoketta)
                        Kisan lajit on suunniteltu niin että kaikilla halukkailla on mahdollisuus osallistua.
                        Kilpailussa on 4 eri sarjaa.</p>
                    <b>SARJAT:</b>
                    <ul>
                        <li>Miehet Rx’d</li>
                        <li>Naiset Rx’d</li>
                        <li>Miehet Skaalattu</li>
                        <li>Naiset Skaalattu</li>
                    </ul>
                    <b>Rx’d</b>
                    <p>Kaikki liikkeet suoritetaan annetuilla liikkeillä ja painoilla.</p>
                    <b>Skaalattu</b>
                    <p>Osa liikkeistä on helpotettu/painot on kevyemmät</p>
                    <p>
                        Molemmissa sarjoissa vähintään nämä liikkeet täytyy osata jotta suoritukset on mahdollista
                        tehdä.
                    <ul>
                        <li><a target="_blank" href="https://m.youtube.com/watch?v=op9kVnSso6Q">Maastaveto
                            levytangolla</a></li>
                        <li><a target="_blank" href="https://m.youtube.com/watch?v=L219ltL15zk"> Thruster
                            levytangolla</a></li>
                        <li><a target="_blank" href="https://m.youtube.com/watch?v=EKRiW9Yt3Ps"> Rinnalleveto
                            levytangolla</a></li>
                        <li><a target="_blank" href="https://m.youtube.com/watch?v=aAggnpPyR6E"> Leuanveto (skaalatussa
                            rengassoutu)</a></li>
                    </ul>
                    <b> Kumpaan sarjaan sitten ilmottautuisin?</b>
                    <p>

                        Vastaus:<br>
                        Jos olet käynyt ohjatuilla Savotta tunneilla ja pystyt suorittamaan sen ilman avustavia
                        välineitä ja annetuilla painoilla niin sarja on Rx’d.
                        Rx’d sarjassa käytettävät painot ovat suunnilleen samoja mitä käytetään ohjatuilla Savotta
                        tunneilla.
                    </p>

                    <b>PALKINNOT 🏆</b>
                    <p>
                        Kaikissa sarjoissa voittaja palkitaan 50€ lahjakortilla undaunted.fi verkkokauppaan. Palkinnot
                        lahjoittaa Outeko Oy.</p>
                    <p>Kaikkien sarjojen 3 parasta palkitaan uniikeilla suomalaisesta koivuvanerista valmistetulla
                        pokaalilla. Palkinnot lahjoittaa Aihkidesign.fi </p>
                    <p>Kaikkien sarjojen 3 parasta palkitaan tuotekasseilla.</p>
                    <p>Kilpailijat saavat äänestää keskuudestaan, omasta mielestään kisassa hienoimman
                        kokonaissuorituksen tehneen kilpailijan. Äänestyksen voittaja palkitaan erikoispalkinnolla.
                    </p>
                    <b>Tapahtumaan palkinnot lahjoittanut</b>
                    <ul>
                        <li>Dynamosali Oy</li>
                        <li>Undaunted.fi</li>
                        <li>Outeko Oy</li>
                        <li>AihkiDesign.fi</li>
                        <li>Undaunted.fi</li>
                        <li>Uittokalusto.fi</li>
                        <li>Kampaamoluona.fi</li>
                        <li>Maijanliikuntapalvelut.fi</li>
                        <li>Levelstore.fi</li>
                    </ul>


                </div>
                <div class="col-xs-12 col-md-6">
                    <img src="/svelte-site/img/ajankohtaista/savottathrowdown.png" />
                </div>
            </div>


        </article>
    </div>
{/if}

<style>


    .yhteistyossa {
        clear: both;
        font-size: 85%;
    }

    .yhteistyossa img {
        float: left;
        height: 90px;
        margin: 8px 32px 8px 0;
    }

    @media all and (max-width: 900px) {
        .yhteistyossa img {
            height: 80px;
        }
    }

</style>
